import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apiUrls from "../../../api";
import { RootState } from "../../../common/state/store";
import { ContentFieldSchema, ContentFieldSchemaEntry } from "../util/FieldDescriptor";

export const fetchContentFieldSchema = createAsyncThunk(
  "graph/fetchContentFieldSchema",
  async () => {
    const response = await axios.get<ContentFieldSchema>(apiUrls.contentFieldSchemas);
    return response.data;
  },
);

interface ContentFieldSchemaState {
  byModelName: ContentFieldSchema;
}

const initialState: ContentFieldSchemaState = {
  byModelName: {},
};

const contentFieldSchemaSlice = createSlice({
  name: "graph/contentFieldSchema",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchContentFieldSchema.fulfilled, (state, action) => {
      state.byModelName = action.payload || {};
    });
    builder.addCase(fetchContentFieldSchema.rejected, (_, action) => {
      console.error("[contentFieldSchema] fetch failed:", action.error);
    });
  },
});

export const getContentFieldSchema =
  (modelName: string) =>
  (state: RootState): ContentFieldSchemaEntry | null =>
    state.contentFieldSchema.byModelName[modelName] ?? null;

export default contentFieldSchemaSlice.reducer;
